import { connect } from 'react-redux'
import { compose } from 'redux'
import { uiRequestOverlayReset, printDataUpdateRequest, printDataPdfReset, deleteNewspaperItem, addNewspaperItem, printDataNewspaperRequest } from '../../../actions'
import { CLI_CINEMA_CLIENT_ID, CLI_MULTICINEMA_MODE, FEATURES, NEWSPAPER_DATA, PRINT_WEEKS, PROGRAM_ATTRIBUTES, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CLI_MOVIES_ORDER, PROGRAM_PERFORMANCES, UI_GENERAL, UI_PROGRAM } from '../../../constants/state'
import getData from '../../../functions/getData'
import toJS from '../../../hoc/toJS'
import PrintNewspaper from '../present/PrintNewspaper'
import filterItemsByOrder from '../../../functions/cinemaAndTimeRangeFilters/filterItemsByOrder'
import filterAttributesByCinema from '../../../functions/cinemaAndTimeRangeFilters/filterAttributesByCinema'
import getOptionalCinemaId from '../../../functions/cinemaAndTimeRangeFilters/getOptionalCinemaId'
import findWeekObWithIsoWeek from '../../../functions/findWeekObWithIsoWeek'
import { BOTTOMITEMS, CHOOSENMOVIES, CUSTOMITEMS, MOVIE } from '../../../constants/itemTypes'
import filterMoviesByWeekAndCinema from '../../../functions/cinemaAndTimeRangeFilters/filterMoviesByWeekAndCinema'
import { v4 as uuidv4 } from 'uuid';

const mapDispatchToProps = (dispatch, ownProps) => ({
    printNewspaperRequest: (printFormatState, printFormat, landscape, activeWeek, printType, cinemaId, printPk, technical) => {
        dispatch(printDataNewspaperRequest(printFormatState, printFormat, landscape, activeWeek, printType, cinemaId, printPk, technical))
    },
    printUpdateRequest: () => {
        dispatch(printDataUpdateRequest())
    },
    onPrintNewspaperPdfResetState: () => {
        dispatch(printDataPdfReset())
        dispatch(uiRequestOverlayReset())
    },
    addNewspaperItem: (itemId, itemType) => {
        if(itemType === MOVIE) {
            const id = uuidv4()
            dispatch(addNewspaperItem({id: id, movieId: itemId, style: 'default', type: itemType, attributes: []}, itemType))
        } else {
            dispatch(addNewspaperItem({id: itemId, type: itemType}, itemType))
        }
    },
    
    deleteNewspaperItem: (itemId, itemType) => {
        dispatch(deleteNewspaperItem(itemId, itemType))
    },
    reorderNewspaperItems: (dragIndex, hoverIndex) => {
        const order = ownProps.newspaperData.choosenMovies.order
        const movedElement = order.splice(dragIndex, 1)[0];
        order.splice(hoverIndex, 0, movedElement);
        // dispatch(updateNewspaperOrder(order, 'choosenMovies'))
    }
})

const mapStateToProps = state => ({
    requestOverlay: getData(state, [UI_GENERAL, 'requestOverlay']),
    features: getData(state, FEATURES),
    newspaperData: getData(state, NEWSPAPER_DATA),
    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),
    movieOrder: getData(state, PROGRAM_CLI_MOVIES_ORDER),
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    performancesData: getData(state, PROGRAM_PERFORMANCES),
    currentClientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    attributesData: getData(state, PROGRAM_ATTRIBUTES),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    weeks: getData(state, PRINT_WEEKS),
})

const PrintNewspaperContainer = ({
    params,
    features,
    newspaperData,
    displayDropzones,
    printNewspaperRequest,
    printUpdateRequest,
    requestOverlay,
    closePagePath,
    weeks,
    movieOrder,
    movieData,
    attributesData,
    performancesData,
    onPrintNewspaperPdfResetState,
    basicUrl,
    currentClientCinemaId,
    multicinemaMode,

    reorderNewspaperItems,
    deleteNewspaperItem,
    addNewspaperItem
}) => {
    const { cinemaId, printType, printFormat, landscape, week, printPk } = params

    if (!newspaperData) {
        return ''
    }

    const dragListConfig = [
        {
            titleTransId: 'section_filter_current_movies',
            buttonTextTransId: null,
            type: MOVIE,
            itemsType: 'currentMovies',
            listType: CHOOSENMOVIES,
            hasAddNewItem: false,
            hasRemoveItem: false
        },
        {
            titleTransId: 'print_upcoming_movies',
            buttonTextTransId: null,
            type: MOVIE,
            itemsType: 'futureMovies',
            listType: CHOOSENMOVIES,
            hasAddNewItem: false,
            hasRemoveItem: false
        },
        {
            titleTransId: 'print_newsletter_content_selection',
            buttonTextTransId: 'program_list_button_new_content',
            type: CUSTOMITEMS,
            itemsType: 'customItems',
            listType: BOTTOMITEMS,
            hasAddNewItem: true,
            hasRemoveItem: true
        }
    ]
    
    let relevantMovies
    const optionalCinemaId = getOptionalCinemaId(multicinemaMode, cinemaId, currentClientCinemaId)

    if(week === "custom") {
        const {dateSettings} = newspaperData
        relevantMovies = filterMoviesByWeekAndCinema(movieOrder, movieData, performancesData, null, cinemaId, dateSettings)   
    } else {
        const weekObj = findWeekObWithIsoWeek(weeks, parseInt(week))
        relevantMovies = filterMoviesByWeekAndCinema(movieOrder, movieData, performancesData, weekObj, cinemaId)
    }

    const relevantMoviesData = {
        order: relevantMovies.relevant,
        items: filterItemsByOrder(relevantMovies.relevant, movieData),
        current: relevantMovies.current,
        future: relevantMovies.future,
        attributes: filterAttributesByCinema(attributesData, optionalCinemaId)
    }

    const { hasChanges, error, status } = newspaperData

    return (
        <PrintNewspaper
            printType={printType}
            cinemaId={cinemaId}
            printID={printFormat}
            dragListConfig={dragListConfig}
            landscape={landscape}
            requestStatus={status}
            printPk={printPk}
            requestError={error}
            basicUrl={basicUrl}
            displayDropzones={displayDropzones}
            relevantMoviesData={relevantMoviesData}
            requestOverlay={requestOverlay}
            activeWeek={week}
            hasChanges={hasChanges}
            features={features}
            newspaperData={newspaperData}
            closePagePath={closePagePath}
            printNewspaperRequest={printNewspaperRequest}
            printUpdateRequest={printUpdateRequest}
            onPrintNewspaperPdfResetState={onPrintNewspaperPdfResetState}
            reorderNewspaperItems={reorderNewspaperItems}
            deleteNewspaperItem={deleteNewspaperItem}
            addNewspaperItem={addNewspaperItem}
        />
    )
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PrintNewspaperContainer)

